import { useState } from "react";

import { SignInBlock } from "@unauthenticated/shared/components";

import { SsoErrorPage } from "../../../../shared/components/SSOErrorBox/types";
import { OAuthStep } from "../oauthStep";

interface Props {
  ssoErrors?: string;
  authErrors?: string;
  onUpdateCurrentStep: (step: OAuthStep) => void;
  setSsoErrorMessage: (error: string) => void;
  onSignInComplete: () => void;
}

const additionalAttributes = {
  redirectPath: window.location.href,
  isOauth: true,
  formVersion: "OAuthSigninPage",
};

const OAuthSignInStep = ({
  ssoErrors,
  authErrors,
  onUpdateCurrentStep,
  setSsoErrorMessage,
  onSignInComplete,
}: Props) => {
  const [errorMessage, setErrorMessage] = useState(authErrors);

  const handleOnCompleted = completedData => {
    const validUser = completedData?.auth?.userSignIn?.user;

    if (validUser) {
      onSignInComplete();
    } else {
      const dataError = completedData?.auth?.userSignIn?.errors.message;
      setErrorMessage(dataError);
    }
  };

  const handleSignUpRedirect = () => {
    setSsoErrorMessage(null);
    onUpdateCurrentStep(OAuthStep.SIGN_UP);
  };

  return (
    <SignInBlock
      ssoErrorPage={SsoErrorPage.OAUTH}
      ssoErrors={ssoErrors}
      onCompleted={handleOnCompleted}
      additionalAttributes={additionalAttributes}
      authErrors={errorMessage}
      onSignUpRedirect={handleSignUpRedirect}
      isOAuth
    />
  );
};

export { OAuthSignInStep };
